/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /* ── BUY NOW ──────────────────────────────────────────────────────
     Adds the item to cart via Fetch API then redirects to /checkout.
     Works alongside Custom Measurements: blocks checkout if measurements
     are incomplete and re-opens the modal with a warning instead.
  ─────────────────────────────────────────────────────────────────── */
  function initBuyNow() {
    var buyNowBtns = document.querySelectorAll('[data-cmx-buynow]');
    if (!buyNowBtns.length) return;

    buyNowBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var root          = document.querySelector('[data-cmx]');
        var orderTypeProp = root ? root.querySelector('[data-cmx-prop="orderType"]') : null;
        var addBtn        = document.querySelector('[data-cmx-add]');

        // Custom mode + measurements incomplete → open modal with warning
        if (orderTypeProp && orderTypeProp.value === 'Custom' && addBtn && addBtn.disabled) {
          var modal       = document.querySelector('[data-cmx-modal]');
          var modalWarnEl = document.querySelector('[data-cmx-modal-warn]');
          if (modal) {
            modal.hidden = false;
            document.documentElement.classList.add('cmx-lock');
            document.body.classList.add('cmx-lock');
          }
          if (modalWarnEl) modalWarnEl.hidden = false;
          if (typeof window.cmxValidate === 'function') window.cmxValidate();
          return;
        }

        var form = root ? root.closest('form') : null;
        if (!form) return;

        var variantInput = form.querySelector('input[name="id"]') || form.querySelector('select[name="id"]');
        var variantId    = variantInput ? variantInput.value : null;
        if (!variantId) return;

        var qtyInput = form.querySelector('input[name="quantity"]');
        var qty      = parseInt(qtyInput ? qtyInput.value : '1', 10) || 1;

        // Collect enabled line item properties
        var properties = {};
        form.querySelectorAll('input[name^="properties["]').forEach(function(i) {
          if (!i.disabled && i.value.trim()) {
            var match = i.name.match(/\[(.+)\]/);
            if (match) properties[match[1]] = i.value.trim();
          }
        });

        var body = { id: variantId, quantity: qty };
        if (Object.keys(properties).length) body.properties = properties;

        var origText    = btn.textContent;
        btn.textContent = '...';
        btn.disabled    = true;

        fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify(body)
        })
        .then(function(r) {
          if (!r.ok) throw new Error('cart/add failed');
          window.location.href = '/checkout';
        })
        .catch(function() {
          btn.textContent = origText;
          btn.disabled    = false;
        });
      });
    });

    // Reset button if user presses Back from checkout (bfcache restore)
    window.addEventListener('pageshow', function(e) {
      if (e.persisted) {
        buyNowBtns.forEach(function(btn) {
          btn.textContent = 'BUY NOW';
          btn.disabled    = false;
        });
      }
    });
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBuyNow);
  } else {
    initBuyNow();
  }

  /* ── BUY NOW VISIBILITY SYNC ─────────────────────────────────────────
     BUY NOW is rendered server-side at page load. When a customer switches
     variant (e.g. S → S+WITH VEIL which is sold out), the theme's JS
     disables ATC but doesn't hide BUY NOW. This observer keeps them in sync.
  ──────────────────────────────────────────────────────────────────── */
  function initBuyNowSync() {
    var atcBtn  = document.querySelector('[data-add-to-cart]');
    var buyNow  = document.querySelector('[data-cmx-buynow]');
    if (!atcBtn || !buyNow) return;

    function syncVisibility() {
      buyNow.style.display = atcBtn.disabled ? 'none' : '';
    }

    syncVisibility(); // run once on load

    new MutationObserver(syncVisibility).observe(atcBtn, {
      attributes: true,
      attributeFilter: ['disabled']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBuyNowSync);
  } else {
    initBuyNowSync();
  }

  /* ── MOBILE SUB-MENU SCROLL INDICATOR ────────────────────────────────
     When COUTURE / BRIDAL sub-menus have more items than fit on screen,
     shows a gradient fade + "scroll" label at the bottom so the user
     knows more collections are below. Fades out once scrolled to the end.
  ──────────────────────────────────────────────────────────────────── */
  function attachScrollHint(panel) {
    if (panel.querySelector('.fjolla-scroll-hint')) return;
    var hint = document.createElement('div');
    hint.className = 'fjolla-scroll-hint';
    hint.setAttribute('aria-hidden', 'true');
    panel.appendChild(hint);

    function update() {
      var atBottom = panel.scrollHeight - panel.scrollTop <= panel.clientHeight + 4;
      hint.style.opacity = atBottom ? '0' : '1';
    }
    update();
    panel.addEventListener('scroll', update, { passive: true });
  }

  function initMobileScrollHints() {
    // Attach to any already-visible panels
    document.querySelectorAll('.mobile__menu__dropdown').forEach(attachScrollHint);

    // Attach whenever a sliderule panel opens (user taps a nav item)
    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-sliderule-open]');
      if (!trigger) return;
      var targetId = trigger.getAttribute('data-sliderule-open');
      var panel = targetId ? document.getElementById(targetId) : null;
      if (panel) {
        var dropdown = panel.querySelector('.mobile__menu__dropdown');
        if (dropdown) {
          setTimeout(function() { attachScrollHint(dropdown); }, 50);
        }
      }
      // Fallback: scan all panels after a short delay
      setTimeout(function() {
        document.querySelectorAll('.mobile__menu__dropdown').forEach(attachScrollHint);
      }, 100);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileScrollHints);
  } else {
    initMobileScrollHints();
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
